import { generatePath as routerGeneratePath } from 'react-router'

import type { Member, Post, Space } from '@tribeplatform/gql-client/types'

export const generatePath = (
  space: Partial<Space>,
  params?: Record<string, string>,
  queryParams?: Record<string, string>,
): string => {
  /**
   * The `(.+)` matcher is a remenant of the old router and the new API in React Router v6
   * does not recognize it. It must be removed from the path before generating the URL.
   */
  const normalizedPath = space?.address?.path?.replace('(.+)', '') ?? ''

  const spacePath = `/${normalizedPath}`
  const path = params ? routerGeneratePath(spacePath, params || {}) : spacePath
  const encodedURI = queryParams
    ? `${path}?${new URLSearchParams(queryParams).toString()}`
    : path
  return decodeURI(encodedURI)
}

export const generateMemberPath = (
  memberSpace: Partial<Space>,
  member: Partial<Member>,
) =>
  memberSpace && member
    ? generatePath(memberSpace, { id: member.id || '' })
    : '/'

export const generatePostPath = (
  postSpace: Partial<Space>,
  space: Partial<Space>,
  post: Partial<Post>,
  reply?: Partial<Post>,
) =>
  postSpace && space && post
    ? generatePath(
        postSpace,
        {
          spacePath: generatePath(space).slice(1),
          postPath: post.slug ? `${post.slug}-${post.id}` : post.id,
        },
        reply?.id ? { highlight: reply?.id } : null,
      )
    : '/'
